<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <form-item-group
      title="Blinds"
      :min="CONSTANT.CREATIVE_DEFAULT_VALUE.SWITCH.MIN_NUM"
      :max="CONSTANT.CREATIVE_DEFAULT_VALUE.SWITCH.MAX_NUM"
      :group-item="CONSTANT.CREATIVE_DEFAULT_VALUE.SWITCH.ITEM"
      v-model="item.blinds"
    >
      <template slot-scope="{ index }">
        <el-form-item
          label="Image"
          :prop="`blinds.${index}.image_url`"
          :rules="[
            ...imageSizeRule(limited_size.image),
            ...urlRule('image_url'),
          ]"
          label-width="120px"
        >
          <file-input
            accept="image/jpeg, image/png, image/gif"
            v-model="item.blinds[index].image_url"
            :check_upload_image_size="{
              ...limited_size.image,
              enable: true,
            }"
          ></file-input>
        </el-form-item>
        <el-form-item
          label="Landing Page"
          :prop="`blinds.${index}.landing_page`"
          :rules="urlRule('landing_page')"
          label-width="120px"
        >
          <el-input v-model="item.blinds[index].landing_page"></el-input>
        </el-form-item>
      </template>
    </form-item-group>
  </el-form>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";
const { SWITCH } = CONSTANT.CREATIVE_DEFAULT_VALUE;
export default {
  data() {
    return {
      item: {
        blinds: [...Array(SWITCH.MIN_NUM)].map(() => _.cloneDeep(SWITCH.ITEM)),
      },
      limited_size: {
        image: {
          width: {
            max: 300,
            min: 300,
          },
          height: {
            max: 250,
            min: 250,
          },
        },
      },
    };
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    setData(row) {
      this.item.blinds = _.map(row.blinds, (blind) => {
        return {
          image_url: decodeURI(blind.image_url),
          landing_page: decodeURI(blind.landing_page),
        };
      });
    },
    async getData(setObj) {
      setObj.blinds = _.map(this.item.blinds, (blind) => {
        return {
          image_url: blind.image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
          landing_page: blind.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
        };
      });
      return setObj;
    },
  },
};
</script>

<style></style>
